/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ContentContainerBodyShift, useFlags } from 'sarsaparilla';
import { ScrollToHash } from 'shared-ui/external-app-base';

import GovShutdownBanner from 'ui-interagency-pass/src/components/GovShutdownBanner';
import AtbAlertBanner from 'ui-interagency-pass/src/components/AtbAlertBanner';
import { WizardProvider } from 'ui-interagency-pass/src/components/PassWizard/context/WizardContext';
import WizardModal from 'ui-interagency-pass/src/components/PassWizard/WizardModal';
import Hero from './landingV2/Hero';
import DigitalIAP from './landingV2/DigitalIAP';
import FindYourPass from './landingV2/FindYourPass';
import SitePass from './landingV2/SitePass';
import WhichPass from './landingV2/WhichPass';

import './landingV2/index.scss';

function NewPassLandingPage() {
    const { releaseDigitalIapFeatures } = useFlags();

    const wizardFlags = {
        wizardEnabled: releaseDigitalIapFeatures?.helpMeChooseWizard ?? false,
        disclaimerEnabled: releaseDigitalIapFeatures?.helpMeChooseDisclaimer ?? false,
    };

    return (
        <div className="new-pass-landing-page">
            <ScrollToHash />
            <WizardProvider flags={wizardFlags}>
                {/* HERO Section */}
                <Hero />
                <div>
                    {/*  Government Shutdown Banner */}
                    <GovShutdownBanner className="mt-6 mb-0" />
                    {/*  ATB Alert Banner (LD-controlled) */}
                    <ContentContainerBodyShift className="mt-4 mb-4">
                        <AtbAlertBanner surface="landing" />
                    </ContentContainerBodyShift>
                    {/*  DIGITAL IAP Section */}
                    <DigitalIAP />
                    {/*  FIND Your Pass Section */}
                    <FindYourPass />
                    {/*  Site Pass Section */}
                    <SitePass />
                    {/*  Which Pass do I Need Section */}
                    <WhichPass />
                </div>
                <WizardModal shouldCloseOnOverlayClick={true} />
            </WizardProvider>
        </div>
    );
}

export default NewPassLandingPage;
